import React from "react"
import IColumn from "../../../yoello-lib/modules/components/lists/interfaces/IColumn"
import TimeStatus from "../../profile/orders/TimeStatus"
import Styles from "../../../scss/orderHistory.module.scss";
import { toLocalDate, toLocalTime } from '../../../yoello-lib/modules/utils/TimeConversion';
import OrderTypeIcon from "../OrderList/OrderTypeIcon";

export const columns: IColumn<any>[] =
    [
        {
            label: "orderHistory.table.orderId", key: "hash_id",
            componentTransform: (orderId) => {
                return <span key={orderId} className={Styles.orderHashId} >
                    {orderId}
                </span>
            }
        },
        {
            label: "orderHistory.table.orderType", key: "order_type",
            componentTransform: (orderType, key) => {
                return <span key={`${key}-order-type`} className={Styles.orderType}>
                    <OrderTypeIcon orderType={orderType} fill={"transparent"} />
                </span>
            },
        },
        {
            label: "orderHistory.table.elapsed", key: "elapsed", componentTransform: (elapsed: number, key) => {
                return <span key={`${key}-elapsed`}><TimeStatus timeDelta={elapsed} /></span>
            }
        },
        {
            label: "orderHistory.table.orderTime", key: "created_on",
            componentTransform: (time, key) => {
                return <span key={`${key}-time`}>{toLocalTime(time)} {window.innerWidth <= 1000 && ","}</span>
            }
        },
        {
            label: "orderHistory.table.orderDate", key: "created_on",
            componentTransform: (date, key) => {
                return <span key={`${key}-date`}>{toLocalDate(date)}</span>
            }
        },
        {
            label: "orderHistory.table.totalPrice", key: "order_total",
            componentTransform: (total, key) => {
                return <span key={`${key}-total`} className={Styles.orderTotalPrice}>{total}</span>
            }
        },
    ]